<template>
	<div class="detailss">
		<p class="details_header">
			<router-link tag="span" to="SampleManagement">
				<i class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"></i>
				样本编号:{{ this.$route.query.id }}
			</router-link>
			<span @click="lookAccessory()" v-if="lookAcc">查看附件</span>
		</p>
		<div class="details_bread">
			<div></div>
			<div>答卷详情</div>
			<div></div>
		</div>
		<div class="details_main">
			<div>
				<p>
					<i class="icon iconfont iconyuandianzhong"></i>
					答题信息
				</p>
				<div class="details_main_xia">
					<span>
						答题序号:
						<span>{{ answerOrder }}</span>
					</span>
					<span>
						答题状态:
						<span>{{ answerState }}</span>
					</span>
					<span>
						来源:
						<span>{{ answerSource }}</span>
					</span>
					<span>
						开始时间:
						<span>{{ startAnswerTime }}</span>
					</span>
					<span>
						结束时间:
						<span>{{ endAnswerTime }}</span>
					</span>
					<span>
						答题时长:
						<span>{{ answerLength }}</span>
					</span>
					<span>
						浏览器:
						<span>未知</span>
					</span>
					<span>
						操作系统:
						<span>未知</span>
					</span>
					<span>
						用户IP:
						<span>{{ answerIP }}</span>
					</span>
				</div>
			</div>
		</div>
		<div class="details_foot">
			<div>
				<p class="details_foot_p">
					<i class="icon iconfont iconyuandianzhong"></i>
					答题信息
				</p>
				<div class="details_foot_main" v-for="(item, index) in questionsList" :key="index">
					<p>{{ item.questionsName }}</p>
					<p class="details_foot_main_data">
						<span v-for="(item, index) in item.options" :key="index">{{ item }}</span>
					</p>
				</div>
			</div>
		</div>

		<!--遮罩层 模态框 -->
		<div v-if="modalBox" class="modalBox"></div>
		<div class="accessory" v-show="accessory">
			<p class="accessoryheader">
				<span>查看附件</span>
				<i @click="closeAccessory" class="wjpc-iconfont wjpc-icon-X"></i>
			</p>
			<div class="accessoryPhoto">
				<p>
					<span></span>
					照片
				</p>
				<ul>
					<p v-if = "answerPhoto=='' ">暂未获取到 图片信息</p>
					<li v-for="(item, index) in answerPhoto" :key="index" :style="{ backgroundImage: 'url(' + item.urlName + ')' }">
						<span><i class="wjpc-iconfont wjpc-icon-lianxirenicon-03"></i></span>
					</li>
				</ul>
			</div>
			<div class="accessoryMp3">
				<p>
					<span></span>
					录音
				</p>
				<!-- 自定义播放组件 -->
				<div class="Mp3">
					<div class="Mp3_l">
						<span></span>
						<span  class="Mp3_l_bg">
							<div class="timeS">
								<label class="startTime">{{ mp3 }}</label>
								<span>/</span>
								<label class="totaltime">{{ mp3Max }}</label>
							</div>
							<!--进度条滑块 <input  type="range" class="ProgressBar" /> -->
						</span>
						<span></span>
						<span @click="last"></span>
						<span @click="l_play" v-show="audioPlay"></span>
						<span @click="next"></span>
						<div class="progress">
							<div class="bar" :style="{width:progress+'%'}"></div>
						</div>
					</div>
					<span class="Mp3_r" @click="r_pause" v-show="audioPause"></span>
				</div>
				<audio ref="player" id="mp3Btn" >
					<source :src="mp3Src" type="audio/mp3" />
					您的浏览器不支持 audio 元素。
				</audio>
				
			</div>
			<div class="accessoryMap">
				<p>
					<span></span>
					定位
				</p>
				
				<div class="accessoryMap_ditu">
					<p v-if="answerCoordinate == '' ">暂未获取到 定位信息</p>
					<p v-else>
						<i class="wjpc-iconfont wjpc-icon-location"></i>
						{{ weizhi }}
					</p>
					<div id="Map_ditu" class="Map_ditu"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript" src="//api.map.baidu.com/api?v=2.0&ak=s32YnrThKzT6VWkqssG6NZrVZzZIGRml"></script>
<script>
export default {
	data() {
		return {
			audioPlay:true,
			audioPause:false,
			// 地址
			answerCoordinate:[],
			// 录音
			answerVoice: [],
			mp3Src: '',
			mp3: 0,
			mp3Max: 0,
			progress:0,
			// 查看附件

			answerPhoto: [],
			// 答题详情
			questionsList: [],
			// 答题信息
			answerIP: '',
			startAnswerTime: '',
			endAnswerTime: '',
			answerLength: '',
			answerSource: '',
			answerState: '',
			answerOrder: '',
			weizhi: '',
			lookAcc:false,
			accessory: false,
			modalBox: false //遮罩层
		};
	},
	mounted: function() {
		this.examineAnswerSheet();
		this.$refs.player.ontimeupdate = this.handlePlayerTimeUpdate;
		// console.log('答卷详情', this.$route.query.id);
		
	},
	methods: {
		examineAnswerSheet() {
			let wid = sessionStorage.getItem('wid');
			let id = localStorage.getItem('userInfo');
			id = JSON.parse(id).id;
			console.log(id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examineAnswerSheet}?id=${this.$route.query.id}&userId=${id}`,
				method: 'GET',
				// data: { 
				// 	id : id,
				// 	userId :this.$route.query.id,
				// },
				cb(res) {
					if (res.code == 0) {
						that.lookAcc=true;
						// console.log('查看单人样本配置', res.resultBody);
						that.answerOrder = res.resultBody.answerOrder;
						that.answerSource = res.resultBody.answerSource;
						that.startAnswerTime = res.resultBody.startAnswerTime;
						that.endAnswerTime = res.resultBody.endAnswerTime;
						that.answerLength = res.resultBody.answerLength;
						that.answerIP = res.resultBody.answerIP;
						let status_code = ['初始样本', '进行中', '读取', '中断', '无效答卷', '配额已满', '正常结束'];
						that.answerState = status_code[res.resultBody.answerState];
						// // 答题详情
						that.questionsList = res.resultBody.questionsList;
						// // 查看附件
						let answerVoice = JSON.parse(res.resultBody.answerVoice);
						that.mp3Max = answerVoice.length;
						for (let i = 0; i < answerVoice.length; i++) {
							that.answerVoice.push(answerVoice[i].urlName);
						}
						that.answerPhoto = JSON.parse(res.resultBody.answerPhoto);
						
						// that.answerCoordinate = res.resultBody.answerCoordinate;
						
						let answerCoordinate = res.resultBody.answerCoordinate;
						if(answerCoordinate == ''){
							that.answerCoordinate = ''
						}else{
							that.answerCoordinate = answerCoordinate.split(',');
						}
						
						// that.$message.success(res.message);
						that.header_map();	
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 地图组件
		header_map() {
			console.log('======',this.answerCoordinate)
			var map = new AMap.Map('Map_ditu', {
				resizeEnable: true, //是否监控地图容器尺寸变化
				zoom: 11, //初始化地图层级
				center: this.answerCoordinate, //初始化地图中心点
				showCircle: true, 
				resizeEnable: true,
				remove:false
			});
			AMap.plugin('AMap.Geocoder', ()=> {
			  var geocoder = new AMap.Geocoder({
			    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
			    city: '全国'
			  })
			  var lnglat = this.answerCoordinate
			
			  geocoder.getAddress(lnglat, (status, result)=> {
			    if (status === 'complete' && result.info === 'OK') {
			        // result为对应的地理位置详细信息
					// console.log(result.regeocode.formattedAddress)
					this.weizhi = result.regeocode.formattedAddress
			    }
			  })
			})
			
			var marker1 = new AMap.Marker({
			    position: this.answerCoordinate,   // 经纬度对象，如 new AMap.LngLat(116.39, 39.9); 也可以是经纬度构成的一维数组[116.39, 39.9]
			});
			map.add(marker1);
		},
		handlePlayerTimeUpdate(){
			// console.log("总时长",this.$refs.player.duration)
			// console.log("当前进度",this.$refs.player.currentTime)
			// console.log("进度百分比",this.$refs.player.currentTime/this.$refs.player.duration)
			this.progress = 100 * this.$refs.player.currentTime/this.$refs.player.duration;
		},
		// 录音组件暂停
		r_pause() {
			this.audioPause = false;
			this.audioPlay = true;
			let audio = this.$refs.player;
			audio.volume = 0.3;
			audio.pause();
			console.log('暂停',)
		},
		// 录音组件播放
		l_play() {
			this.audioPlay = false;
			this.audioPause = true;
			let audio = this.$refs.player;
			audio.volume = 0.3;
			audio.src=this.answerVoice[this.mp3];
			audio.play();
			console.log('播放',this.mp3Src);
		},
		// 上一首
		last() {
			this.mp3--;
			if (this.mp3 < 0) {
				this.mp3 = 0;
			}
			
			this.mp3Src = this.answerVoice[this.mp3];
			this.l_play();

			console.log('上一首', this.mp3Src);
		},
		// 下一首
		next() {
			this.mp3++;
			if (this.mp3 >= this.mp3Max) {
				this.mp3 = this.mp3Max;
			}
			this.mp3Src = this.answerVoice[this.mp3];
			this.l_play();

			console.log('下一首',this.mp3Src);
		},
		// 查看附件
		lookAccessory() {
			this.modalBox = true;
			this.accessory = true;
			this.header_map();
			
		},
		// 关闭查看附件
		closeAccessory() {
			this.modalBox = false;
			this.accessory = false;
			this.r_pause()
		}
	},
	created() {}
};
</script>

<style scoped lang="scss">
html {
	// height: 100%;
	background-color: #f5f5f5;
}
.detailss {
	width: 100%;
	height: 100%;
	background-color: #f5f5f5;
	li {
		list-style: none;
	}
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
	}
	.details_bread {
		max-width: 1200px;
		background-color: #fff;
		margin: auto;
		display: flex;
		justify-content: center;
		padding-top: 29px;
		font-size: 22px;
		div:nth-child(odd) {
			width: 40px;
			height: 3px;
			margin: 15px 5px 0px 5px;
			background: #0080ff;
		}
	}
	.details_main {
		max-width: 1200px;
		margin: auto;
		padding-top: 70px;
		background-color: #fff;
		div:nth-child(1) {
			padding-left: 70px;
			p {
				font-size: 16px;
				color: #0080ff;
				margin-bottom: 10px;
			}
			.details_main_xia {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-left: 10px;
				span {
					width: 33.333%;
					height: 30px;
				}
			}
		}
	}
	.details_foot {
		max-width: 1200px;
		margin: auto;
		padding: 30px 0px;
		background-color: #fff;
		div:nth-child(1) {
			padding-left: 70px;
			.details_foot_p {
				font-size: 16px;
				color: #0080ff;
				margin-bottom: 10px;
			}
			.details_foot_main {
				border-top: 1px solid #ccc;
				width: 90%;
				// height: 90px;
				// line-height: 90px;
				.details_foot_main_data{
					height: auto;
					display: flex;
					 flex-wrap:wrap ;
				}
				p:nth-child(1) {
					margin-top: 20px;
				}
				p:nth-child(2) {
					margin-top: 10px;
					span {
						padding: 10px;
					}
				}
			}
		}
	}
	//  遮罩层
	.modalBox {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1001;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.3;
	}
	/*模态框*/
	.accessory {
		position: absolute;
		background: #fff;
		width: 900px;
		min-height: 1010px;
		opacity: 1;
		z-index: 2001;
		top: 0%; /*偏移*/
		left: 50%;
		margin-left: -450px;
		.accessoryheader {
			height: 60px;
			line-height: 60px;
			text-align: center;
			border-bottom: 1px solid #0080ff;
			span {
				color: #333;
				font-size: 18px;
			}
			i {
				float: right;
				padding-right: 20px;
			}
		}
		.accessoryPhoto {
			margin-left: 30px;
			p {
				height: 53px;
				line-height: 53px;
				font-size: 16px;
				color: #333333;
				span {
					height: 16px;
					border: 3px solid #0080ff;
					border-radius: 8px;
					margin-right: 7px;
				}
			}
			ul {
				height: 250px;
				display: flex;
				overflow-y: auto;
				li {
					width: 240px;
					height: 240px;
					background-repeat: no-repeat;
					background-size: contain;
					background-color: #f8f8f8;
					background-position: center;
					box-shadow: 5px 5px 5px #888888;
					border-radius: 10px;
					margin-right: 25px;
					span {
						width: 30px;
						height: 30px;
						border-radius: 50%;
						background-color: #9ea5a5;
						float: right;
						text-align: center;
						line-height: 30px;
						font-size: 15px;
						color: #fff;
						margin: 5px 5px;
					}
				}
			}
		}
		.accessoryMp3 {
			margin-left: 30px;
			p {
				height: 53px;
				line-height: 53px;
				font-size: 16px;
				color: #333333;
				span {
					height: 16px;
					border: 3px solid #0080ff;
					border-radius: 8px;
					margin-right: 7px;
				}
			}
			.Mp3 {
				width: 767px;
				height: 88px;
				position: relative;
				.Mp3_l {
					width: 693px;
					height: 88px;
					display: inline-block;
					position: relative;
					display: flex;
					position: relative;
					span {
						display: inline-block;
					}
					span:nth-child(1) {
						width: 150px;
						height: 88px;
						background: url('../assets/luyin/left.png') repeat-x;
					}
					.Mp3_l_bg {
						flex: 1;
						width: 10px;
						height: 88px;
						background: url('../assets/luyin/center.png');

						div {
							display: inline;
							line-height: 88px;
						}
						.timeS {
							z-index: 1000;
							position: absolute;
							right: 200px;
						}
						// .ProgressBar{  进度条滑块
						// 	width:400px;
						// 	background-color: #ccc;
						// 	position: absolute;
						// 	top:56px;
						// 	left:115px;
						// }
					}
					span:nth-child(3) {
						width: 207px;
						height: 88px;
						background: url('../assets/luyin/right.png');
					}
					span:nth-child(4) {
						width: 40px;
						height: 40px;
						background: url('../assets/luyin/prev.png');
						position: absolute;
						top: 25px;
						right: 111px;
					}
					span:nth-child(5) {
						width: 53px;
						height: 53px;
						background: url('../assets/luyin/play.png');
						position: absolute;
						top: 18px;
						right: 57px;
					}
					span:nth-child(6) {
						width: 40px;
						height: 40px;
						background: url('../assets/luyin/next.png');
						position: absolute;
						top: 25px;
						right: 16px;
					}
					.progress{
						    position: absolute;
						    left: 112px;
						    right: 162px;
						    top: 17px;
						    bottom: 17px;
						    height: 53px;
						    border-radius: 50px;
							overflow: hidden;
						    background-color: #E0E0E0;
							.bar{
								content: "";
								display: block;
								height: 100%;
								background-color: #F47795;
							}
					}
				}
				.Mp3_r {
					width: 53px;
					height: 53px;
					background-color: #eeedec;
					background: url('../assets/luyin/stop.png');
					position: absolute;
					top: 20px;
					right: 0px;
				}
			}
		}
		.accessoryMap {
			margin-left: 30px;
			p {
				height: 53px;
				line-height: 53px;
				font-size: 16px;
				color: #333333;
				span {
					height: 16px;
					border: 3px solid #0080ff;
					border-radius: 8px;
					margin-right: 7px;
				}
			}
			.accessoryMap_ditu {
				p {
					.iconlocation {
						font-size: 20px;
						color: #0080ff;
					}
				}
				.Map_ditu {
					width: 863px;
					height: 370px;
				}
			}
		}
	}
}
</style>
